import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import { useInView } from 'react-intersection-observer';
import { Container } from 'components/UI';
import { Title, Loader } from '@landing/ui';
import Slider from 'components/Slider';
import Slide from './Slide';
import { useIsSsr } from 'utils/hooks';
import { isPastMeetup } from 'utils';

import * as styles from './Projects.module.scss';

const CorporateForm = lazy(() => import('../CorporateForm'));
const Animation = lazy(() => import('components/UI/Animation'));

export default function Projects({ title, subtitle, slides, formTitle }) {
  const isSsr = useIsSsr();
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });

  return (
    <div className={styles.wrapper} id="projects">
      <Container className={styles.container} background="transparent">
        <div className={styles.layout}>
          <Title color="white">{title}</Title>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          <div className={cn(styles.sliderWrapper, 'defaultSlider')} ref={inViewRef}>
            {inView && (
              <Slider slides={slides}>
                {slides.map(slide => (
                  <div key={slide.title} className={styles.slide}>
                    <Slide {...slide} />
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </div>
      </Container>
      {!isPastMeetup() && (
        <Container background="transparent">
          <div className={styles.formLayout}>
            <div className={styles.formContent}>
              <Title className={styles.formTitle} color="white">
                {formTitle}
              </Title>
            </div>
            <div className={styles.formWrapper}>
              {!isSsr && (
                <Suspense fallback={<Loader theme="fullHeight" />}>
                  <CorporateForm className={styles.form} captchaInfo={false} />
                </Suspense>
              )}
            </div>
          </div>
        </Container>
      )}
      {!isSsr && (
        <Suspense fallback={null}>
          <Animation preserveAspectRatio className={styles.animation} name="about" />
        </Suspense>
      )}
    </div>
  );
}
